import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '../services';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const isValidSession = authenticationService.checkSessionValidity();
        
        if (isValidSession) {
          return <Component {...props} />;
        } else {
          // Redirigir al login si no está autenticado o la sesión expiró
          return <Redirect to="/login" />;
        }
      }}
    />
  );
};

export default ProtectedRoute;

